export default __webpack_public_path__ + "static/media/arbb-cover.55aec44c.png";